import { ExportEngine, type ExportFormat, type ExportResult } from '@memberjunction/export-engine';

/**
 * Hands an ExportEngine result to the browser as a download (committee scores .xlsx, program status .csv).
 * Throws the engine error (or `failure`) when the export failed; nothing is clicked then. The object URL
 * is revoked and the temporary anchor removed once the click has been dispatched (UBP §10).
 */
export function OEPDownloadExport(result: ExportResult, fileName: string, format: ExportFormat, failure: string): void {
    if (!result.success || !result.data) throw new Error(result.error ?? failure);
    // A fresh ArrayBuffer-backed copy: ExportResult.data is typed Uint8Array<ArrayBufferLike>, which BlobPart does not accept.
    const blob = new Blob([new Uint8Array(result.data)], { type: result.mimeType ?? ExportEngine.getMimeType(format) });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    try {
        a.href = url;
        a.download = result.fileName ?? `${fileName}.${ExportEngine.getFileExtension(format)}`;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
    } finally {
        a.remove();
        URL.revokeObjectURL(url);
    }
}
